export default __webpack_public_path__ + "static/media/insurenceone.4cbd2548.svg";